import { Trans } from 'react-i18next';

interface IProps {
  fileName: string;
  allowTranslation: boolean;
}

const ErrorReachedLimit = ({ fileName, allowTranslation = false }: IProps) =>
  allowTranslation ? (
    <span>
      <Trans ns="ui" i18nKey="photoUploadLimit.validation">
        {{ fileName }}
        <div>wasn't uploaded.</div>
        Files upload limit reached.
      </Trans>
    </span>
  ) : (
    <span>
      {fileName}
      <div>wasn't uploaded.</div>
      Files upload limit reached.
    </span>
  );

export default ErrorReachedLimit;
